import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { FileServiceProviderType } from '../Enums/FileServiceProviderType.enum';

import { InputOneDriveFspConfig } from './InputOneDriveFspConfig.entity';
import { InputWebDavFspConfig } from './InputWebDavFspConfig.entity';

export class InputFileServiceProviderConfig<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: any;
  /** Alias: name */
  name?: any;
  /** Alias: providerType */
  providerType?: FileServiceProviderType;
  /** Alias: configSharePoint */
  configSharePoint?: InputOneDriveFspConfig<T>;
  /** Alias: configWebDav */
  configWebDav?: InputWebDavFspConfig<T>;
  /** Alias: convertPath */
  convertPath?: any;
  /** Alias: isWorkDirectory */
  isWorkDirectory?: boolean;

  __typename?: string;
}

const fields: FieldDefinitions<InputFileServiceProviderConfig> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  providerType: {
    alias: 'providerType',
  },
  configSharePoint: {
    alias: 'configSharePoint',
  },
  configWebDav: {
    alias: 'configWebDav',
  },
  convertPath: {
    alias: 'convertPath',
  },
  isWorkDirectory: {
    alias: 'isWorkDirectory',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputFileServiceProviderConfigEntityDefinition: EntitiyDefinition<InputFileServiceProviderConfig> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputFileServiceProviderConfig',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
